import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import P from "layouts/wrapper/P";
import { useContext, useRef, useState } from 'react';
import logo_bottom from "resources/puffu/icon/logo.png";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import style from "./Main.module.scss";

import Center from "layouts/wrapper/Center";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section4 from "./Section4";
import Section5 from "./Section5";

import { Drawer, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Dummy from "layouts/wrapper/Dummy";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { Waypoint } from "react-waypoint";
import CircularSlider from './CircularSlider';
import RenewSection5 from "./renew/RenewSection5";
import RenewSection2A from "./renew/RenewSection2A";
import RenewSection2B from "./renew/RenewSection2B";
import Section6A from "./Section6A";
import Section6B from "./Section6B";
import Section6C from "./Section6C";
import { textFormat } from "resources/regExp";
import InputText from "./inputs/InputText";
import RenewSection3 from "./renew/RenewSection3";
import RenewSection4 from "./renew/RenewSection4";
import FixedTextAnimation from "./renew/FixedTextAnimation";
import RenewSection6A from "./renew/RenewSection6A";
import RenewSection6B from "./renew/RenewSection6B";
import RenewSection7 from "./renew/RenewSection7";
import RenewSection8 from "./renew/RenewSection8";
import RenewSection9 from "./renew/RenewSection9";
import { useNavigate, Link } from "react-router-dom";
import PrivacyPolicy from "./privacyPolicy/PrivacyPolicy";
import { validateInputs } from "utils/Utils";
import emailjs from '@emailjs/browser';
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation, Pagination, Scrollbar, Virtual } from "swiper/modules";
import logo from "resources/puffu/icon/logo2.svg";
import Section15 from "./Section15";




function Main5({onslideChange, activeSlideCurrent}) {
    const { isMobile } = useContext(BrowserDetectContext);
    const navigate = useNavigate();
    const form = useRef();
    // const { t } = useTranslation();
    const section1Ref = useRef(null);
    const section2Ref = useRef(null);
    const section4Ref = useRef(null);
    const section5Ref = useRef(null);
    const section6Ref = useRef(null);
    const section8Ref = useRef(null);
    const [headerColor, setHeaderColor] = useState('rgba(16,18,24,1)');
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isAnimationActive, setIsAnimationActive] = useState(false);
    const [renewSection5Enter, setRenewSection5Enter] = useState(false);
    const [chartAnimationActive, setChartAnimationActive] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    const [enter, setEnter] = useState(false);
    const inputs = useRef([]);
    const [isPrivacyOpen, setPrivacyOpen] = useState(false);

    const togglePrivacyPopup = () => {
        setPrivacyOpen((prev) => !prev);
    };

    const sendEmail = (e) => {
        e.preventDefault();

        // 이름과 연락처 필드 값 확인
        const nameValue = inputs.current[0]?.value.trim();
        const contactValue = inputs.current[1]?.value.trim();

        // 입력 값이 비어 있는 경우 알림 띄우기
        if (!nameValue || !contactValue) {
            if (!nameValue) {
                alert("이름을 입력해주세요.");
            } else if (!contactValue) {
                alert("연락처를 입력해주세요.");
            }
            return;
        }

        // validateInputs 함수 실행
        validateInputs(inputs.current).then((result) => {
            if (result.isValid) {
                if (isChecked) {
                    emailjs
                        .sendForm('service_b285e47', 'template_e33t8vp', form.current, 'NTQEMWapvtBIX44tO')
                        .then(
                            (result) => {
                                alert("가맹문의 신청이 완료되었습니다! 빠른 시일내에 연락드리겠습니다.");
                                form.current.reset();
                                setIsChecked(false);
                            },
                            (error) => {
                                alert("가맹문의 신청에 실패했습니다.");
                            }
                        );
                } else {
                    alert("약관에 동의해주세요");
                }
            } else {
                alert("기입사항을 다시 확인해주세요");
            }
        });
    };



    const handleEnterSection2 = () => {
        setIsAnimationActive(true);
    };

    const handleLeaveSection = (color) => () => {

        if (window.scrollY < 300) {

            setHeaderColor('rgba(16,18,24,1)');
        } else {
            setHeaderColor(color);  // 섹션을 떠날 때 색상 변경

        }
    };

    const handleEnterSection = (color) => () => {
        setHeaderColor(color);  // 섹션이 다시 보일 때 이전 색상으로 변경

    };
    const enterSection = () => {
        setEnter(true);
    }
    const handleEnterSection5 = () => {
        console.log("RenewSection5에 도달했습니다."); // 디버깅용 로그
        setRenewSection5Enter(true);
    };

    const scrollToSection = (ref) => {

        window.scrollTo({
            top: ref.current.offsetTop,
            behavior: 'smooth',
        });
        setDrawerOpen(false);  // 메뉴 클릭 시 드로어 닫기
    };

    const onScrollTopClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        setDrawerOpen(false);  // 메뉴 클릭 시 드로어 닫기
    };
    const scrollToBottom = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth',
        });
    };

    const [headerActive, setHeaderActive] = useState('');


    return (
        <div style={{ position: "relative", backgroundColor: "var(--main-color)" }}>

            {/* 헤더 영역 */}
            {/* {!isMobile && (
                
            )} */}
            <div className={`${style.header_wrap} ${headerActive}`}>

                <div className={style.logoBox}>
                    <HorizontalFlex gap={!isMobile ? 15 : 5} width={'auto'} alignItems={'end'}>
                        <FlexChild justifyContent={"flex-end"}>
                            <P font={"gmarketSansBold"} color={"white"} size={!isMobile ? 18 : 12}>24시 무인전자담배</P>
                        </FlexChild>
                        <FlexChild justifyContent={"flex-start"}>
                            <img src={logo} width={!isMobile ? 100 : 80} style={{ filter: "brightness(1000%)" }} />
                        </FlexChild>
                    </HorizontalFlex>
                </div>

                <div className={style.header_inner}>
                    <div className={style.company_btn}>
                        <Link to={'/Company'}>
                            <P font={"gmarketSansBold"} size={!isMobile ? 18 : 14} color={'#fff'}>회사소개</P>
                        </Link>
                    </div>
    
                    <div className={style.headerContact}>
                        <P size={18} font={"gmarketSansBold"} color={"white"}>가맹문의</P>
                        <P font={"gmarketSansBold"} color={"white"} className={style.headerContactNumber}>070-4242-2000</P>
                    </div>
                </div>
            </div>

            

            <Swiper
                 direction="vertical"
                 modules={[Mousewheel, Pagination, Scrollbar]}
                 slidesPerView={1}
                 mousewheel={{forceToAxis: true, releaseOnEdges: false}} 
                 simulateTouch={isMobile}
                 style={{ height: "100dvh" }}
                 nested={true} // 내부 스크롤 허용
                 onSlideChange={(swiper) => {
                    // if (swiper.activeIndex === 1) { // RenewSection2A가 위치한 슬라이드 인덱스
                    //     setIsAnimationActive(true);
                    // }

                    switch (swiper.activeIndex) {
                        case 1:
                            setIsAnimationActive(true);
                            break;
                        case 4:
                            setEnter(true);
                            break;
                        case 7:
                            setChartAnimationActive(true);
                            break;
                        default:
                            break;
                    }

                    if(isMobile) {
                        const current = swiper.activeIndex;
                        const previous = swiper.previousIndex;
                        const lastIndex = swiper.slides.length - 1;

                        // if (current === lastIndex) {
                        //     activeSlideCurrent(true);
                        // } else {
                        //     setHeaderActive(style.out);
                        //     activeSlideCurrent(false);
                        // } 
                        
                        
                        
                        if (current === lastIndex) {
                            setHeaderActive('');
                            // activeSlideCurrent(true);
                        } else if (current > previous) {
                            setHeaderActive(style.out);
                            // onslideChange('down');

                        } else if (previous > current) {
                            setHeaderActive('');
                            // onslideChange('up');

                        }
                    }
                }}
            >
                <SwiperSlide>
                    <div ref={section1Ref} style={{ backgroundColor: "var(--main-color)", width: "100%", height: "100dvh" }}>
                        <Section1 />
                        {/* <Waypoint onLeave={handleEnterSection2} topOffset="60%" /> */}
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section2Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        {/* {
                            isMobile &&
                            <Waypoint onEnter={handleEnterSection2} topOffset={"20%"} />
                        } */}
                        <RenewSection2A isAnimationActive={isAnimationActive} />
                        {/* {
                            !isMobile &&
                            <Waypoint onEnter={handleEnterSection2} topOffset={"20%"} />
                        } */}
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section2Ref} style={{ backgroundColor: "var(--main-color)", width: "100%", height: "100dvh" }}>
                        <RenewSection2B />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section4Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        {/* <Waypoint onLeave={handleEnterSection('rgba(16,18,24,1)')} onEnter={handleLeaveSection('#FCFBF7')} /> */}
                        <RenewSection3 ref={section4Ref} onLeave={handleLeaveSection('#FCFBF7')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section5Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        {/* <Waypoint onLeave={enterSection} onEnter={handleEnterSection5} topOffset="5%" /> */}
                        <RenewSection4 ref={section5Ref} enter={enter} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section6Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <RenewSection5 />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <RenewSection6A />
                        {/* <Dummy height={"7.5vh"} /> */}
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <RenewSection6B chartAnimationActive={chartAnimationActive}/>
                        {/* <Dummy height={"7.5vh"} /> */}
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <RenewSection7 />
                        {/* <Dummy height={"15vh"} /> */}
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <RenewSection8 />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        {/* <Dummy height={"15vh"} /> */}
                        <RenewSection9 />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <Section6A />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <Section6B />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div ref={section8Ref} style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <Section6C />
                    </div>
                </SwiperSlide>
                {/* 모바일에만 추가되는 푸푸 연락처 페이지 */}
                {isMobile && 
                <SwiperSlide>
                    <div style={{ backgroundColor: "#fff", width: "100%", height: "100dvh" }}>
                        <Section15 />
                    </div>
                </SwiperSlide>
                }
           
            </Swiper>


            



            {/* 하단 신청 푸터 영역 */}
            {
                isMobile
                    ?
                    null
                    :
                    <div
                        style={{
                            position: "fixed",
                            bottom: 0,
                            zIndex: 999,
                            width: "100%",
                            height: "auto",
                            backgroundColor: "rgba(54, 54, 54, 1)",
                            padding: "10px 0",
                        }}
                    >
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"100%"} justifyContent={"flex-start"}>
                                <form
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                    ref={form} onSubmit={sendEmail}
                                >
                                    <div style={{ display: "flex", gap: "12px", width: "90%", justifyContent: "center", alignItems: "center" }}>
                                        <input
                                            type="text"
                                            placeholder="이름"
                                            required
                                            name={"이름"}
                                            ref={el => (inputs.current[0] = el)}
                                            style={{
                                                width: "30%",
                                                maxWidth: "300px",
                                                height: "40px",
                                                padding: "10px",
                                                borderRadius: "5px",
                                                border: "1px solid rgba(200, 200, 200, 1)",
                                                fontSize: "min(2vw, 16px)",
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="연락처"
                                            name={"연락처"}
                                            ref={el => (inputs.current[1] = el)}
                                            required
                                            style={{
                                                width: "30%",
                                                maxWidth: "300px",
                                                height: "40px",
                                                padding: "10px",
                                                borderRadius: "5px",
                                                border: "1px solid rgba(200, 200, 200, 1)",
                                                fontSize: "min(2vw, 16px)",
                                            }}
                                        />
                                        <div style={{ width: "205px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <input
                                                type="checkbox"
                                                id="agreeCheckbox"
                                                onChange={handleCheckboxChange} checked={isChecked} style={{ width: "22px", height: "22px", border: "none", cursor: "pointer" }}
                                            />
                                            <label
                                                htmlFor="agreeCheckbox"
                                                style={{
                                                    color: "white",
                                                    fontSize: "min(2vw, 18px)",

                                                    cursor: "pointer",
                                                    textWrap: "nowrap",
                                                    display: 'flex',
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    paddingLeft: "10px"
                                                }}
                                                onClick={togglePrivacyPopup}
                                                onMouseEnter={(e) => {
                                                    e.target.style.textDecoration = "underline"; // hover 시 밑줄 추가
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.textDecoration = "none"; // hover 벗어나면 밑줄 제거
                                                }}
                                            >
                                                개인정보 수집 동의
                                            </label>
                                        </div>
                                        <div
                                            style={{
                                                cursor: "pointer",
                                                width: "max-content",
                                                backgroundColor: "rgba(254, 83, 31, 1)",
                                                height: "48px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "5px",
                                                padding: "0 38px"
                                            }}
                                            onClick={sendEmail}
                                        >
                                            <button
                                                type="button"
                                                style={{
                                                    color: "white",
                                                    fontWeight: 700,
                                                    fontSize: "clamp(18px, 2.6vw, 20px)",
                                                    width: "max-content",
                                                    background: "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                }}

                                            >
                                                신청
                                            </button>
                                        </div>
                                    </div>


                                </form>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
            }







            
            {/* Popup Modal */}
            {isPrivacyOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "10px",
                            width: "90%",
                            maxWidth: "500px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <PrivacyPolicy />
                        <button
                            onClick={togglePrivacyPopup}
                            style={{
                                marginTop: "10px",
                                padding: "10px 20px",
                                backgroundColor: "rgba(254, 83, 31, 1)",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                width: "100%",
                            }}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            )}


        </div>
    );
}

export default Main5;